var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('FooterMobile'):_c('FooterPc')
}
var staticRenderFns = []

export { render, staticRenderFns }